"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessError = exports.JobStatus = void 0;
var JobStatus;
(function (JobStatus) {
    JobStatus["INITIALIZED"] = "initialized";
    JobStatus["QUEUED"] = "queued";
    JobStatus["PROCESSING"] = "processing";
    JobStatus["COMPLETED"] = "complete";
    JobStatus["CANCELLED"] = "cancelled";
    JobStatus["SUCCESS"] = "success";
    JobStatus["FAILED"] = "fail";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
var ProcessError;
(function (ProcessError) {
    ProcessError["TIMEOUT"] = "timeout";
    ProcessError["LIMIT_EXCEEDED"] = "limit exceeded";
    ProcessError["HTTP"] = "http";
})(ProcessError = exports.ProcessError || (exports.ProcessError = {}));
